import React from "react";
import Enrollment from "./compoment/Enrollment";
import "./css/enrollmentForm.css";

const EnrollmentForm = () => {
  return (
    <section id="enrollment" className="p-md-4 p-0">
      <div className="container my-sm-0 mb-sm-3  my-5">
        <div className="bg-enrollment">
          <Enrollment />
        </div>
      </div>
    </section>
  );
};

export default EnrollmentForm;
